<div class="iq-nav-bar">
  <iq-nav-bar-logo></iq-nav-bar-logo>
  <div class="iq-nav-bar--main-bar"></div>
</div>
<div class="iq-outlet-container">
  <section class="iq-content-container content-container">
    <div class="iq-icon-container">
      <div class="iq-image-icon--general-error"></div>
    </div>
    <h5>
      {{ 'errors.server.genericError' | translate }}
    </h5>

    <div class="btn-container">
      <button type="button" class="button  secondary-1" routerLink="/portal">
        Return To Dashboard
      </button>
    </div>
  </section>
</div>
